import Axios from "axios"

export async function getCountries() {
    let data = []
    try {
        const response = await Axios({
            "method": "GET",
            "url": "https://api-football-v1.p.rapidapi.com/v2/countries",
            "headers": {
                "content-type": "application/octet-stream",
                "x-rapidapi-host": "api-football-v1.p.rapidapi.com",
                "x-rapidapi-key": "4a924e26e2msh6cbbda7a5553cb0p10cffcjsn999d1a4b9b45",
                "useQueryString": true
            }
        })
        data = response.data.api.countries
    } catch (error) {

    }
    return data
}

export async function getLeagues() {
    let data = []
    try {
        const response = await Axios.get("https://api-football-v1.p.rapidapi.com/v2/leagues/current",
            {
                headers: {
                    "x-rapidapi-key": "4a924e26e2msh6cbbda7a5553cb0p10cffcjsn999d1a4b9b45"
                }
            }
        )
        if (response?.data?.api?.leagues) {
            data = response.data.api?.leagues
        }
    } catch (error) {

    }
    return data
}

export async function getLeagueStandings(leagueId, season) {
    let data = []
    try {
        const response = await Axios({
            "method": "GET",
            "url": "https://api-football-v1.p.rapidapi.com/v2/leagueTable/" + leagueId + "/" + season,
            "headers": {
                "content-type": "application/octet-stream",
                "x-rapidapi-host": "api-football-v1.p.rapidapi.com",
                "x-rapidapi-key": "4a924e26e2msh6cbbda7a5553cb0p10cffcjsn999d1a4b9b45",
                "useQueryString": true
            }
        })
        if (response?.data?.api?.standings) {
            data = response.data.api.standings
        }

    } catch (error) {

    }
    return data
}

export async function getSingleTeamById(teamId) {
    let data = []
    try {
        const response = await Axios({
            "method": "GET",
            "url": "https://api-football-v1.p.rapidapi.com/v2/teams/team/" + teamId,
            "headers": {
                "content-type": "application/octet-stream",
                "x-rapidapi-host": "api-football-v1.p.rapidapi.com",
                "x-rapidapi-key": "4a924e26e2msh6cbbda7a5553cb0p10cffcjsn999d1a4b9b45",
                "useQueryString": true
            }
        })
        data = response?.data?.api?.teams[0];
    } catch (error) {

    }
    return data
}

export async function getSquadTeam(teamId, season) {
    let data = []
    try {
        const response = await Axios({
            "method": "GET",
            "url": "https://api-football-v1.p.rapidapi.com/v2/players/team/" + teamId + "/" + season,
            "headers": {
                "content-type": "application/octet-stream",
                "x-rapidapi-host": "api-football-v1.p.rapidapi.com",
                "x-rapidapi-key": "4a924e26e2msh6cbbda7a5553cb0p10cffcjsn999d1a4b9b45",
                "useQueryString": true
            }
        })
    } catch (error) {

    }
    return data
}

export async function searchTeamsApi(searchTerm) {
    let data = []
    try {
        let url =
            'https://api-football-v1.p.rapidapi.com/v2/teams/search/' +
            searchTerm

        const response = await Axios({
            method: 'GET',
            url: url,
            headers: {
                'content-type': 'application/octet-stream',
                'x-rapidapi-host': 'api-football-v1.p.rapidapi.com',
                'x-rapidapi-key':
                    '4a924e26e2msh6cbbda7a5553cb0p10cffcjsn999d1a4b9b45',
                useQueryString: true,
            },
        })
        if (response?.data?.api?.teams) {
            data = response.data.api.teams
        }
    } catch (error) {

    }
    return data
}

export async function getPlayerApi(playerId) {
    let data = []
    try {
        const response = await Axios({
            "method": "GET",
            "url": "https://api-football-v1.p.rapidapi.com/v2/players/player/" + playerId,
            "headers": {
                "content-type": "application/octet-stream",
                "x-rapidapi-host": "api-football-v1.p.rapidapi.com",
                "x-rapidapi-key": "4a924e26e2msh6cbbda7a5553cb0p10cffcjsn999d1a4b9b45",
                "useQueryString": true
            }
        })
        data = response.data.api.players
    } catch (error) {

    }
    return data
}

export async function getFixturesByDate(date) {
    let data = []
    try {
        const response = await Axios({
            "method": "GET",
            "url": "https://api-football-v1.p.rapidapi.com/v2/fixtures/date/" + date,
            "headers": {
                "content-type": "application/octet-stream",
                "x-rapidapi-host": "api-football-v1.p.rapidapi.com",
                "x-rapidapi-key": "4a924e26e2msh6cbbda7a5553cb0p10cffcjsn999d1a4b9b45",
                "useQueryString": true
            }, "params": {
                "timezone": "Europe/London"
            }
        })
        data = response.data.api.fixtures
    } catch (error) {

    }
    return data
}

export async function getFixtureByTeamIdAndType(teamId, type, count = 1) {
    let data
    try {
        const response = await Axios({
            "method": "GET",
            "url": "https://api-football-v1.p.rapidapi.com/v2/fixtures/team/" + teamId + "/" + type + "/" + count,
            "headers": {
                "content-type": "application/octet-stream",
                "x-rapidapi-host": "api-football-v1.p.rapidapi.com",
                "x-rapidapi-key": "4a924e26e2msh6cbbda7a5553cb0p10cffcjsn999d1a4b9b45",
                "useQueryString": true
            }, "params": {
                "timezone": "Europe/London"
            }
        })
        if (response?.data?.api?.fixtures) {
            data = response?.data?.api?.fixtures
        }
    } catch (error) {

    }
    return data
}

export async function getSingleFixture(fixtureId) {
    let data = []
    try {
        const response = await Axios({
            "method": "GET",
            "url": "https://api-football-v1.p.rapidapi.com/v2/fixtures/id/" + fixtureId,
            "headers": {
                "content-type": "application/octet-stream",
                "x-rapidapi-host": "api-football-v1.p.rapidapi.com",
                "x-rapidapi-key": "4a924e26e2msh6cbbda7a5553cb0p10cffcjsn999d1a4b9b45",
                "useQueryString": true
            }, "params": {
                "timezone": "Europe/London"
            }
        })
        data = response.data.api.fixtures[0]
    } catch (error) {

    }
    return data
}

